import type { RoomMetadata, WebinarModeData } from 'api/types';

const isActiveWebinarMode = (webinarMode?: WebinarModeData): boolean => Boolean(webinarMode?.enabled);

/**
 * Не затираем webinarMode, если сервер прислал metadata без него или с частичным объектом
 * (аналогично сохранению moderators в updateRoomMetadata).
 */
export const mergeWebinarModeFromServer = (incoming: RoomMetadata, current: RoomMetadata | null): RoomMetadata => {
    const incomingWebinar = incoming.webinarMode;
    const currentWebinar = current?.webinarMode;

    if (incomingWebinar?.enabled === false) {
        return incoming;
    }

    if (incomingWebinar === undefined) {
        if (currentWebinar !== undefined) {
            return { ...incoming, webinarMode: currentWebinar };
        }
        return incoming;
    }

    if (!isActiveWebinarMode(currentWebinar)) {
        return incoming;
    }

    return {
        ...incoming,
        webinarMode: {
            ...currentWebinar,
            ...incomingWebinar,
            enabled: incomingWebinar.enabled ?? currentWebinar?.enabled,
            speakers: incomingWebinar.speakers ?? currentWebinar?.speakers,
        },
    };
};
